import React, { useEffect, useRef, useState } from "react";
import { motion, useInView, useScroll, useTransform } from "framer-motion";
import { useLang } from "../LanguageContext";
import { Reveal, Overline, LineReveal } from "./Reveal";
import { optImg } from "../lib/img";

const Counter = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [display, setDisplay] = useState(value);
  const num = parseInt(value.replace(/\D/g, ""), 10);
  const suffix = value.replace(/[0-9]/g, "");

  useEffect(() => {
    if (!inView || isNaN(num)) return;
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.floor(eased * num) + suffix);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, num, suffix]);

  return <span ref={ref}>{isNaN(num) ? value : display}</span>;
};

const Heritage = () => {
  const { t, images } = useLang();
  const IMAGES = images;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section id="about" className="bg-paper py-24 md:py-36 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 md:gap-24 items-center">
        <div ref={ref} className="relative aspect-[4/5] overflow-hidden order-2 md:order-1">
          <motion.img style={{ y: imgY }} src={optImg(IMAGES.factory, 1000)} alt="" loading="lazy" decoding="async" className="absolute inset-0 h-[120%] w-full object-cover" />
          <div className="absolute inset-0 ring-1 ring-inset ring-black/10" />
        </div>

        <div className="order-1 md:order-2">
          <Reveal><Overline>{t.heritage.overline}</Overline></Reveal>
          <h2 className="font-serif text-ink font-light leading-[1.05] text-4xl md:text-6xl mt-7">
            <LineReveal>{t.heritage.title}</LineReveal>
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 text-ink/65 text-lg font-light leading-relaxed max-w-lg">{t.heritage.body}</p>
          </Reveal>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-border pt-10">
            {t.heritage.stats.map((s, i) => (
              <Reveal key={i} delay={0.1 + i * 0.1}>
                <div>
                  <p className="font-serif text-ink text-4xl md:text-5xl font-light"><Counter value={s.value} /></p>
                  <p className="mt-2 text-ink/55 text-xs uppercase tracking-[0.15em] font-light">{s.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Heritage;
